import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.clientes.clasificacion.delete}
                postUrl={api.clientes.clasificacion.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Tipo de Empresa ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                buttonTitle={"Eliminar Tipo de Empresa"}
                title={"Eliminar Tipo de Empresa"}
                buttonIcon={"fa fa-trash fa-lg"}
                saveButton={true}
                closeButton={true}
                buttonClass={"btn-danger"}
                danger={true}
                saveButtonLabel={"Eliminar"}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        <span>Esta acción eliminará el tipo de empresa seleccionado.</span>
                    </div>
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del tipo</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/clientes/ClasificacionEmpresa/Delete.js